import { globalAxiosClient } from "./client";

const userAnalyticsContextUrl = "/api/Private/user-analytics-context";

export interface UserAnalyticsContextData {
  userId: string;
  emailMd5: string;
  emailSha256: string;
  loansCount: number;
  totalLoansGrantedAmount?: number;
  hasBadPaymentBehavior?: boolean;
  lastProductRequestCode?: string;
  lastProductRequestStatus?: string;
  userSource: string;
}

export function getUserAnalyticsContext(authToken: string) {
  return globalAxiosClient
    .get<UserAnalyticsContextData>(userAnalyticsContextUrl, {
      headers: { Authorization: `Bearer ${authToken}` },
    })
    .then((response) => response.data);
}
